<template>
	<div :class="{ 'form-group': true, 'has-danger': error, 'clearfix': true }">
		<slot></slot>
		<small v-if="error" class="form-text text-danger">* {{ error }}</small>
		<slot name="help"></slot>
	</div>
</template>

<script>
export default {
	name: 'FormGroup',
	props: {
		error: {
			type: String,
			default: null,
		},
		formGroupClass: {
			type: String,
			default: '',
		},
		errorTextClass: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/themes/variables.scss';

.has-danger input {
	border-color: $danger;
}

</style>



// WEBPACK FOOTER //
// src/components/elements/FormGroup.vue